import { BuildClass, TW_OVERFLOW_ELLIPSIS, fsmData, } from '../../../../universal';
import { React, _ } from '../../../lib';
import { IRIS } from '../../component-iris';
import { cacheZipFile } from '../../component-pdf-viewer';
import { AddButton, Button, ButtonTW } from '../buttons';
import { Checkbox } from '../checkbox';
import { Combobox } from '../combobox';
import { DateBox } from '../date';
import { LoadingSpinnerLarge } from '../loading';
import { CJSX } from '../meta-types';
import { Textbox } from '../textbox';
import { dummyFP } from '../wrappers';
import { Action, buildReport, sendOnUpdate } from './actions';
const errClass = 'block text-xl mt-20 text-center text-[#888]';
export const ReportOptionPane = (props) => {
    if (!props.rs.state.cache) {
        return React.createElement(LoadingSpinnerLarge, null);
    }
    if (props.report == null) {
        return React.createElement("div", { className: errClass }, "Select a Report");
    }
    if (props.report === 'report-jobs') {
        return getReportJobMetaForm(props.rs);
    }
    const rj = props.rs.props.reportJobs?.items[-props.report];
    if (rj != null) {
        return getReportJobOptionsForm(props.rs, rj);
    }
    const report = props.rs.props.reportIndex[props.report];
    if (!report) {
        return React.createElement("div", { className: errClass }, "Select a Report");
    }
    const params = props.rs.state.cache?.params?.[report.Key] ?? [];
    const exports = props.rs.state.cache.exports?.[report.Key] ?? [];
    const cmpts = _.map(params, param => getComponent(props.rs, param.Type, param.Key, param.Label, param.Options));
    if (props.report == null) {
        return React.createElement("div", { className: errClass }, "Select a report");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "overflow-y-scroll max-h-[calc(100%-66px)]" }, cmpts),
        React.createElement("div", { key: "buttons", className: "text-center mb-[10px]" },
            React.createElement("div", { className: BuildClass({
                    'mb-1': true,
                    invisible: _.isEqual(props.rs.state.options[report.Key], props.rs.state.defaultOptions[report.Key]),
                }) },
                React.createElement("a", { className: "text-blue-600 hover:text-red-600 text-sm cursor-pointer", onClick: () => {
                        props.rs.dispatch([
                            Action.ResetOptions,
                            { reportKey: report.Key },
                        ]);
                    } }, "Reset options to default")),
            React.createElement(CJSX, { cond: _.includes(exports, 1) },
                React.createElement(ButtonTW, { className: "min-w-[92px] max-w-[92px] bg-[#edc] hover:bg-[#fdd] active:bg-[#fdd]", style: { marginLeft: '1px', marginRight: '1px' }, lbl: "Build PDF", onClick: () => {
                        buildReport(props.rs, 1);
                    } })),
            React.createElement(CJSX, { cond: _.includes(exports, 2) },
                React.createElement(ButtonTW, { className: "min-w-[92px] max-w-[92px] bg-[#ded] hover:bg-[#cfc] active:bg-[#cfc]", style: { marginLeft: '1px', marginRight: '1px' }, lbl: "Build XLSX", onClick: () => {
                        buildReport(props.rs, 2);
                    } })),
            React.createElement(CJSX, { cond: _.includes(exports, 3) },
                React.createElement(ButtonTW, { className: "min-w-[92px] max-w-[92px]", style: { marginLeft: '1px', marginRight: '1px' }, lbl: "Build CSV", onClick: () => {
                        buildReport(props.rs, 3);
                    } })))));
};
const getReportJobMetaForm = (rs) => (React.createElement("div", { className: "text-center align-middle m-[10px] leading-5" },
    React.createElement("p", { className: "mb-4 text-left" }, "Report jobs are custom-made lists of reports with the parameters and export types already set."),
    React.createElement("p", { className: "mb-4 text-left" }, "You can click the \"Jobs\" button on the left to open the report job manager to add or edit report jobs."),
    React.createElement("div", null,
        React.createElement(AddButton, { type: "ui5-borderless-24", lbl: "Add Report Job", onClick: () => {
                rs.props.reportJobs?.openWindow?.(-1);
            } }))));
const getReportJobOptionsForm = (rs, rj) => {
    const count = _.size(rj.Reports);
    const s = count === 1 ? '' : 's';
    const runReportJob = () => {
        const rpt = rs.state.selectedReport;
        if (!rpt) {
            return;
        }
        rs.dispatch([
            Action.UpdateFormState,
            {
                reportKey: rpt,
                isLoading: true,
                loadProg: null,
                iframeSrc: null,
                pdfURL: null,
                errorMessage: '',
            },
        ]);
        if (rs.props.reportJobs == null) {
            rs.dispatch([
                Action.UpdateFormState,
                {
                    reportKey: rpt,
                    errorMessage: 'Report jobs are not defined',
                    isLoading: false,
                },
            ]);
            return;
        }
        IRIS.Send({
            data: {
                progID: rs.props.progID,
                funcID: rs.props.reportJobs?.funcID,
                reportJob: rj.ID,
            },
            prog: x => {
                rs.dispatch([Action.UpdateFormState, { reportKey: rpt, loadProg: x }]);
            },
            any: () => {
                rs.dispatch([
                    Action.UpdateFormState,
                    {
                        reportKey: rpt,
                        isLoading: false,
                        loadProg: null,
                    },
                ]);
            },
            no: data => {
                rs.dispatch([
                    Action.UpdateFormState,
                    { reportKey: rpt, errorMessage: data.message },
                ]);
            },
            yes: (data) => {
                const name = rj.Name.replace(/[^a-zA-Z0-9-]/g, '-');
                cacheZipFile(data.hashCode, data.output, name, url => {
                    rs.dispatch([
                        Action.UpdateFormState,
                        { reportKey: rpt, iframeSrc: url },
                    ]);
                }).catch(err => {
                    console.error(err);
                });
            },
        });
    };
    return (React.createElement("div", { className: "text-center align-middle" },
        React.createElement("div", { className: "p-3 text-center" },
            React.createElement("a", { className: "text-blue-600 hover:text-red-600 cursor-pointer hover:no-underline", onClick: e => {
                    e.preventDefault();
                    rs.props.reportJobs?.openWindow?.(rj.ID);
                    return false;
                } }, "Edit report job")),
        React.createElement(Button, { type: "submit", lbl: `Build ${count} Report${s}`, onClick: runReportJob }),
        React.createElement("ul", { className: "text-left my-4 pl-6 list-disc" }, fsmData(rj.Reports, {
            sort: x => x.Name,
            map: x => (React.createElement("li", { key: x.Name },
                React.createElement("div", { className: TW_OVERFLOW_ELLIPSIS }, x.Name))),
        }))));
};
export const getComponentType = (rs, type) => {
    const cmpt = definedComponentsGeneric[type] ?? rs.props.getReportComponent(type);
    if (!cmpt) {
        console.error(`Unknown report component: "${type}"`);
        return {
            defVal: () => null,
            cmpt: () => React.createElement("div", null,
                "Error loading option of type \"",
                type,
                "\""),
        };
    }
    return cmpt;
};
const getComponent = (rs, cmpt, key, lbl, options) => {
    const rpt = getComponentType(rs, cmpt);
    const rkey = rs.props.reportIndex[rs.state.selectedReport ?? -1]?.Key;
    if (!rkey) {
        console.error(`Could not find report key: ${rkey}`);
        return React.createElement(React.Fragment, null);
    }
    const component = React.cloneElement(rpt.cmpt({ label: lbl, options: options }), {
        key: 'cmpt',
        className: BuildClass({
            [rpt.className ?? '']: true,
            'max-w-full min-w-full': true,
        }),
        value: (rs.state.options[rkey]?.[key] ?? null),
        onUpdate: (v) => {
            const val = (rpt.validate ?? _.identity)(v);
            rs.dispatch([Action.UpdateOptions, { [key]: val }]);
            sendOnUpdate(rs);
        },
    });
    const lblDisplay = cmpt != 'TypeBool' ? lbl : '';
    return (React.createElement("label", { key: key, className: BuildClass({
            block: true,
            [rpt.paddingClass ?? 'pt-[5px] pb-[10px] px-[10px]']: true,
            [rpt.className ?? '']: true,
        }) },
        React.createElement("span", { className: "block font-condensed font-light px-1 text-[#555]" }, lblDisplay),
        component));
};
export const definedComponentsGeneric = {
    TypeBool: {
        defVal: () => false,
        paddingClass: 'pt-0 pb-0 px-[10px]',
        cmpt: x => (React.createElement(Checkbox, { ...dummyFP, className: "text-sm text-[#444]", classNameInner: "before:inline before:text-xl before:leading-5 hover:text-black", classNameLabel: "inline leading-[21px]", lbl: x.label })),
    },
    TypeString: { defVal: () => '', cmpt: () => React.createElement(Textbox, { ...dummyFP }) },
    TypeInteger: { cmpt: () => React.createElement(Textbox, { ...dummyFP }) },
    TypeFloat: { cmpt: () => React.createElement(Textbox, { ...dummyFP }) },
    TypeDate: {
        cmpt: () => React.createElement(DateBox, { ...dummyFP }),
        validate: (v) => v?.fmt() ?? null,
    },
    TypeGeneric_SetOfInts: { cmpt: () => React.createElement(Textbox, { ...dummyFP }) },
    TypeEnum: {
        defVal: () => null,
        cmpt: x => React.createElement(Combobox, { options: x.options ?? [], ...dummyFP }),
    },
    TypeEnumMulti: {
        defVal: () => [],
        cmpt: x => React.createElement(Combobox, { options: x.options ?? [], ...dummyFP, multiple: true }),
    },
};
//# sourceMappingURL=options.js.map